var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"text-decoration":"underline","margin-bottom":"0"}},[_vm._v("Prévisualisation")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.results,"fields":_vm.fields.entete,"per-page":"5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }